<template>
  <a-row>
    <a-space v-if="editIs" class="m-8">
      <a-button v-hasPermi="['bom:bomRoutingLineCc:add']" class="m-r-8" type="primary" @click="onShowAdd">新增</a-button>
      <a-button v-hasPermi="['bom:bomRoutingLineCc:list']" class="m-r-8" @click="getTableList">刷新</a-button>
    </a-space>
    <ls-api-table
      ref="dataTable"
      :tableProps="tableProps"
      :columns="columns"
      :scroll="{ x: 400, fixScreen: true }"
      bordered
    >
      <!-- 工序号 -->
      <template slot="operationSeqNum" slot-scope="{ record }">
        <a-input-number class="full-width" v-if="record.editIs" v-model="record.operationSeqNum" />
        <div v-else>{{ record.operationSeqNum }}</div>
      </template>
      <!-- 工序编码 -->
      <template slot="operationId" slot-scope="{ record }">
        <!-- <ls-select-page
          v-model="record.operationCode"
          :datas="operationCodeList"
          allowClear
          show-search
          :disabled="!editIs"
          :placeholder="editIs ? '请选择' : ''"
          :searchKey="['label', 'realValue']"
          value-key="selectedValue"
          @change="(operationId) => operationCodeOnChange(operationId, record)"
        >
          <template slot="select-option" slot-scope="{ items }">
            <a-select-option v-for="(item) in items" :key="item.selectedValue">
              {{ `${item.label}-${item.realValue}` }}
            </a-select-option>
          </template>
        </ls-select-page> -->
        {{ record.operationId }}
      </template>
      <!-- 类型 -->
      <template slot="operationType" slot-scope="{ record }">
        <ls-select-page
          v-if="record.editIs"
          class="full-width"
          v-model="record.operationType"
          :datas="operationTypeList"
          searchKey="lookupValue"
          valueKey="lookupCode"
        >
          <template slot="select-option" slot-scope="{ items }">
            <a-select-option
              v-for="item in items"
              :key="item.lookupCode"
            >{{ item.lookupValue }}</a-select-option>
          </template>
        </ls-select-page>
        <template v-else>{{ $lookupMeaning(operationTypeList, record.operationType) }}</template>
      </template>
      <!-- 是否防跳站 -->
      <template slot="skipFlag" slot-scope="{ record }">
        <a-select v-if="record.editIs" class="full-width" v-model="record.skipFlag">
          <a-select-option v-for="(item) in jumpOptions" :key="item.value">{{ item.label }}</a-select-option>
        </a-select>
        <template v-else>{{ renderEnumName('skipFlag' ,record.skipFlag) }}</template>
      </template>
      <template #edmitOperation="{ record, index }">
        <template v-if="editIs">
          <a-icon v-if="record.loading" type="loading" />
          <template v-if="!record.editIs && !record.loading">
            <a-button v-hasPermi="['bom:bomRoutingLineCc:edit']" type="link" class="m-r-8" href="javascript:;" @click="onEdit(record)">
              <a-icon type="edit" />
            </a-button>
            <ls-cancel v-hasPermi="['bom:bomRoutingLineCc:remove']" @confirm="onDeleteRow(record, index)" title="确定要删除吗?">
              <a-icon type="delete" title="删除" />
            </ls-cancel>
          </template>
          <template v-else>
            <template>
              <a-button type="link" @click="onSaveEdit(record)"><a-icon type="check" /></a-button>
              <a-button type="link" @click="onCancelEdit(record)"><a-icon type="close" /></a-button>
            </template>
          </template>
        </template>
      </template>
    </ls-api-table>
    <ProcessSelectModal
      ref="processSelectModalRef"
      :operationTypeList="operationTypeList"
      :detailData="detailData"
      @successCall="getTableList"
    />
  </a-row>
</template>

<script>
import isNil from 'lodash/isNil'
import { IS_JUMP_STATION, PROCESS_TYPE } from '../enums.js';
import {
  apiGetBomRoutingLineCc, apiBomOperationFindList, apiUpdateBomRoutingLineCc,
  apiDeleteBomRoutingLineCc
} from '@/api/mes/basedata/standardProcessNew';
import { generateLsTableResData } from '@/utils/util'
import ProcessSelectModal from './process-select-modal.vue';

export default {
  name: 'ProcessTable',
  components: { ProcessSelectModal },
  props: {
    editIs: {
      type: Boolean,
      default: true
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    detailData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      operationCodeList: [], // 工序编码
      operationTypeList: [], // 工序类型
      tableProps: {
        requestApi: generateLsTableResData(apiGetBomRoutingLineCc)
      },
      columns: [
        {
          title: '顺序号',
          dataIndex: 'operationSeqNum',
          scopedSlots: { customRender: 'operationSeqNum' },
          width: 100,
          align: 'center'
        },
        {
          title: '工序编码',
          dataIndex: 'operationCode',
          // scopedSlots: { customRender: 'operationCode' },
          width: 140,
          align: 'center'
        },
        {
          title: '工序名称',
          dataIndex: 'operationDesc',
          width: 100,
          align: 'center'
        },
        {
          title: '类型',
          dataIndex: 'operationType',
          scopedSlots: { customRender: 'operationType' },
          width: 140,
          align: 'center'
        },
        {
          title: '是否防跳站',
          dataIndex: 'skipFlag',
          scopedSlots: { customRender: 'skipFlag' },
          width: 140,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'edmitOperation',
          scopedSlots: { customRender: 'edmitOperation' },
          align: 'center',
          width: 90
        }
      ]
    }
  },
  computed: {
    jumpOptions() {
      return Object.values(IS_JUMP_STATION);
    },
    processTypeOptions() {
      return Object.values(PROCESS_TYPE)
    }
  },
  watch: {
    detailData: {
      handler() {
        this.$nextTick(() => {
          this.getTableList();
        })
      }
    }
  },
  mounted() {
    this.getOptions();
    this.getTableList();
    // this.getOperationCodeList();
  },
  methods: {
    getTableList(currentPage) {
      const { id: routingId } = this.detailData;
      if(routingId) {
        this.$refs.dataTable.searchParams = { routingId };
        this.$refs.dataTable.getData(!!currentPage);
      }
    },
    renderEnumName(enumName, value) {
      let item;
      if (enumName === 'skipFlag') {
        item = this.jumpOptions.find(item => item.value === value);
      }else if(enumName === 'processType') {
        item = this.processTypeOptions.find(item => item.value === value);
      }
      return item?.label;
    },
    // 添加子层级
    onShowAdd() {
      this.$refs.processSelectModalRef.show();
    },
    onEdit(record) {
      record.tempData = { ...record };
      this.$set(record, 'editIs', true);
    },
    onSaveEdit(record) {
      const { skipFlag, operationType, operationSeqNum } = record;
      if(this.isEmpty(skipFlag) || this.isEmpty(operationType) || this.isEmpty(operationSeqNum)) {
        return this.$message.error('请填写完整数据');
      }
      const { id: routingId } = this.detailData;
      const { id, operationId } = record;
      const params = { routingId, id, operationId, operationType, operationSeqNum, skipFlag };
      this.$set(record, 'loading', true)
      apiUpdateBomRoutingLineCc(params).then((res) => {
        if(res.code === 200) {
          this.$message.success('保存成功');
          this.getTableList(true);
        }
      }).finally(() => {
        record.loading = false;
      });
    },
    onCancelEdit(record) {
      Object.assign(record, record.tempData);
      record.editIs = false;
      delete record.tempData;
    },
    onDeleteRow(record, index) {
      this.$emit('delete', record, index);
      this.$set(record, 'loading', true)
      apiDeleteBomRoutingLineCc(record.id).then((res) => {
        if(res.code === 200) {
          this.$message.success('保存成功');
          this.getTableList();
        }
      }).finally(() => {
        record.loading = false;
      });
    },
    genOpposedText(text) {
      return isNil(text) ? '' : text ? '是' : '否'
    },
    // 工序编码
    operationCodeOnChange (selectedOperationId, record) {
      const tempSelectedItem = this.operationCodeList.find(item => selectedOperationId === item.selectedValue)
      record.operationId = selectedOperationId
      record.operationDesc = tempSelectedItem.realValue
      record.operationCode = tempSelectedItem.label
    },
    // 工序编码-下拉框数据
    getOperationCodeList () {
      apiBomOperationFindList({ pageSize: 999999 }).then(res => {
        this.operationCodeList = res?.rows || []
      })
    },
    getOptions() {
      // 工序类型
      const lookupQueryParams = {
        lookupType: 'MES_OPERATION_TYPE_CC',
        current: 1,
        pageSize: 999
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this.operationTypeList = response.rows || [];
      })
    },
    //
    isEmpty(value) {
      return value === null || value === undefined || value === ''
    }
  }
}
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}
.m-r-8 {
  margin-right: 8px;
}
.m-8 {
  margin: 8px 0;
}
.text-3-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-all;
  height: 63.5px;
}
/deep/.ant-btn-link {
  padding: 0 4px;
}
.read-selection {
  /deep/.ant-select-selection {
    border: 0;
    user-select: text;
  }
  /deep/.ant-select-selection__rendered {
    margin-right: 0;
  }
  /deep/.ant-select-selection--single .ant-select-selection__rendered {
    margin-left: 0;
  }
  /deep/.ant-select-disabled .ant-select-selection {
    background: transparent;
    cursor: unset;
  }
  /deep/.ant-select-disabled {
    color: inherit;
  }
  /deep/.ant-select-arrow {
    display: none;
  }
  /deep/.ant-input-number-disabled {
    background: transparent;
    border: 0;
    color: inherit;
  }
}
</style>
